import { SplitPane } from '@/Layout/SplitPane';
import { DraggableDrawer } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { FC, memo, ReactNode } from 'react';
import styles from './SplitPaneDrawer.module.scss';

const cx = classnames.bind(styles);

export type Props = {
  title: ReactNode;
  isVisible: boolean;
  width?: number;

  leftPaneContent: ReactNode;
  rightPaneClassName?: string;
  footerContent: ReactNode;

  leftPaneClassName?: string;
  rightPaneContent: ReactNode;

  isMask?: boolean;

  onClose: () => void;
};

export const SplitPaneDrawer: FC<Props> = memo(
  ({
    title,
    isVisible,
    width,
    onClose,
    leftPaneContent,
    leftPaneClassName,
    rightPaneContent,
    rightPaneClassName,
    footerContent,
    isMask,
  }) => {
    return (
      <DraggableDrawer
        contentContainerClassName={cx(styles['drawer-container'])}
        width={width}
        title={title}
        onClose={onClose}
        visible={isVisible}
        footer={footerContent}
        mask={isMask}
      >
        <SplitPane
          leftPaneContent={leftPaneContent}
          rightPaneContent={rightPaneContent}
          leftPaneClassName={leftPaneClassName}
          rightPaneClassName={rightPaneClassName}
        />
      </DraggableDrawer>
    );
  }
);
SplitPaneDrawer.displayName = 'SplitPaneDrawer';
